import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin } from "rxjs";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
import { MessagingService } from "../../messaging/messaging.service";
import { MessagingStructure } from "src/app/services/features-by-plan/interface/messaging";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-campaign-setup",
  templateUrl: "./campaign-setup.component.html",
  styleUrls: ["./campaign-setup.component.scss"],
})
export class CampaignSetupComponent implements OnInit {
  public loading = false;
  private BASE_URL = GlobalVariable;
  // shorturl: boolean;
  outlet_id: string;
  is_messaging_blocked: any;
  promotionalSenderId: any;
  campaignSetupForm: FormGroup;
  isValidFormSubmitted: boolean;
  chooseTransactionalChannel: string;
  choosePromotionalChannel: string;
  allTransactionalChannel = [];
  allPromotionalChannel = [];
  whatsappAllowed: boolean;
  isAdvancedSchedulingAllowed: boolean = false;
  settingField = {
    setup: {
      header: "General",
      transactionalDefaultChannel: {
        title: "Transactional Default Channel",
        description:
          "Default messaging channel for Transactional Type Messages",
      },
      promotionalDefaultChannel: {
        title: "Promotional Default Channel",
        description: "Default messaging channel for Promotional Type Messages",
      },
      promotionalSenderID: {
        title: "Promotional Sender ID",
        description:
          "DLT Sender ID of the Business through which Promotional Messages get sent",
      },
      transactionalSenderID: {
        title: "Transactional Sender ID",
        description:
          "DLT Sender ID of the Business through which Transactional Messages get sent",
      },
      allowAdvanceScheduling: {
        title: "Allow Advance Scheduling",
        description: "Number of days in advance that messages can be scheduled",
      },
    },
  };

  messagingFeatureStructure: MessagingStructure =
    this.messagingService.messagingFeature;
  permissions: any;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    public formBuilder: FormBuilder,
    private messagingService: MessagingService,
    private commonService: CommonService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.loading = true;
    this.outlet_id = this.storage.get("outlet_id");
    this.campaignSetupForm = this.formBuilder.group({
      promotional_sender_id: [""],
      transactional_sender_id: [""],
      advanceSchedulingUnit: ["", Validators.required],
      advanceSchedulingValue: ["", Validators.required],
    });
    this.commonMessagingSettings();
    this.messagingService
      .checkIsFeatureApplicable("advance_scheduling")
      .then((res) => {
        this.isAdvancedSchedulingAllowed = res;
      });
  }

  get campaignSetupFormControl() {
    return this.campaignSetupForm.controls;
  }

  chooseTransactionalType($event) {
    this.chooseTransactionalChannel = $event;
  }

  choosePromotionalType($event) {
    this.choosePromotionalChannel = $event;
  }

  commonMessagingSettings() {
    this.HttpService.get(
      this.BASE_URL.MESSAGING_COMMON_SETTINGS_V3(this.outlet_id)
    ).subscribe((data: Response) => {
      // this.shorturl = res.data["short_url"] === true ? true : false;
      this.is_messaging_blocked = data.data["is_product_blocked"];
      this.campaignSetupForm.patchValue({
        promotional_sender_id: data.data["promotional_sender_id"] ?? "",
        transactional_sender_id: data.data["transactional_sender_id"] ?? "",
        advanceSchedulingUnit: data.data["post_advance_type"] ?? "",
        advanceSchedulingValue: data.data["post_advance_value"] ?? "",
      });

      // set restriction on the transaction sender id
      // if value is there then it can't be empty
      let transactionSenderId =
        this.campaignSetupForm.controls["transactional_sender_id"];
      if (data.data["transactional_sender_id"]) {
        transactionSenderId.setValidators([
          Validators.required,
          Validators.minLength(6),
        ]);
      } else {
        transactionSenderId.clearValidators();
      }
      transactionSenderId.updateValueAndValidity();

      // transactional Channels
      this.allTransactionalChannel = data.data["transactional_channels"];
      this.allTransactionalChannel.forEach((element: any) => {
        element.id = "t" + element.value;
        // if (element.value == "Email") {
        //   element.isDisabled = true;
        // }
      });

      // promotional Channels
      this.allPromotionalChannel = data.data["promotional_channels"];
      this.allPromotionalChannel.forEach((element: any) => {
        element.id = "p" + element.value;
        if (element.value == "Email") {
          element.isDisabled = true;
        }
      });

      this.permissions = data.data["permissions"];

      this.choosePromotionalChannel = data.data?.default_promotional_channel;
      this.chooseTransactionalChannel =
        data.data?.default_transactional_channel || "SMS";
    });
    this.loading = false;
  }

  // shorturlChange(event) {
  //   this.shorturl = event;
  // }

  onSubmit() {
    let res: Response;
    this.isValidFormSubmitted = false;
    if (this.campaignSetupForm.invalid) {
      return;
    }
    this.isValidFormSubmitted = true;

    const data_json = {
      // short_url: this.shorturl,
      promotional_sender_id:
        this.campaignSetupFormControl.promotional_sender_id.value,
      transactional_sender_id: this.campaignSetupFormControl
        .transactional_sender_id.value
        ? this.campaignSetupFormControl.transactional_sender_id.value
        : null,
      default_transactional_channel:
        this.chooseTransactionalChannel.toUpperCase(),
      default_promotional_channel: this.choosePromotionalChannel.toUpperCase(),
      post_advance_type: this.isAdvancedSchedulingAllowed
        ? this.campaignSetupFormControl.advanceSchedulingUnit.value
        : null,
      post_advance_value: this.isAdvancedSchedulingAllowed
        ? this.campaignSetupFormControl.advanceSchedulingValue.value
        : null,
    };
    const data_service = this.HttpService.putjson(
      this.BASE_URL.MESSAGING_COMMON_SETTINGS_V3(this.outlet_id),
      this.commonService.removeEmptyFromObject(data_json)
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        // this.toastrService.warning(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201 || res.code === 206) {
          this.toastrService.success(res.data["message"]);
        } else {
          this.toastrService.warning(res.data["message"]);
        }
      }
    );
  }

  onDiscard() {
    this.commonMessagingSettings();
  }
}
